import { render } from "./Teacher22.vue?vue&type=template&id=6aa99f40&scoped=true"
import script from "./Teacher22.vue?vue&type=script&lang=js"
export * from "./Teacher22.vue?vue&type=script&lang=js"

import "./Teacher22.vue?vue&type=style&index=0&id=6aa99f40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa99f40"]])

export default __exports__